import { FieldState, LinkField, isFilled } from '@prismicio/client';
import cn from 'classnames';
import { PrismicError } from '@components/PrismicError';
import PrismicLink from '@components/PrismicLink/PrismicLink';

type LinkVariant = 'primary' | 'secondary' | 'ghost';

type PrismicButtonProps = {
  field: LinkField<string, string, unknown, FieldState, LinkVariant>;
  className?: string;
};

const getClassNameForVariant = (variant: LinkVariant) => {
  switch (variant) {
    case 'primary':
      return 'tw-lf-button-primary';

    case 'secondary':
      return 'tw-lf-button-secondary';

    case 'ghost':
      return 'tw-lf-button-ghost';
  }
};

export const PrismicButton = ({ field, className }: PrismicButtonProps) => {
  if (!isFilled.link(field)) {
    return <PrismicError />;
  }

  const variant = field.variant ?? 'primary';

  return (
    <PrismicLink
      link={field}
      className={cn(
        'tw-lf-button tw-lf-button-md',
        getClassNameForVariant(variant),
        className,
      )}
    >
      {field.text}
    </PrismicLink>
  );
};
